import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import {
  CompaniesActionTypes,
  SetFilters
} from '../actions';

@Injectable()
export class CompaniesEffects {
  filtersParams$ = createEffect(
    () => this.actions$.pipe(
      ofType(CompaniesActionTypes.SetFilters),
      map((filters: SetFilters) => {
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: filters.payload, queryParamsHandling: '', replaceUrl: true })
      })
    ),
    { dispatch: false }
  )

  constructor(
    private actions$: Actions,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }
}
